<template>
<div class="has-text-centered" ref="preview-container">
  <canvas ref="preview" :width="canvasWidth" :height="canvasHeight" class="preview-canvas"></canvas>
</div>
</template>

<script>
import progressBars from '@/helpers/design/progress-bars'
import animations from '@/helpers/design/animations'
// import sampleWave from '@/helpers/design/sample-wave'
import sampleWaves from '@/helpers/design/sample-waves'

const WATERMARK_SRC = 'https://s3-us-west-2.amazonaws.com/wavve-assets/wavve-watermark.png'
let watermarkLoaded = false
let watermarkImg

export default {
  name: 'DesignAnimatedPreview',
  props: {
    design: Object,
    watermark: Boolean,
  },
  data() {
    return {
      canvasWidth: 640,
      canvasHeight: 640 * (this.design.height / this.design.width),
      backgroundImageFile: null,
      animationFrame: 0,
      totalFrames: sampleWaves.length - 1,
      animationTimeout: null,
      refreshTimeout: 1000 / 24,
    }
  },
  mounted() {
    this.ctx = this.$refs.preview.getContext('2d')
    this.ctx.patternQuality = 'best'
    this.resize()
    if (this.design.backgroundImage) {
      this.backgroundImageFile = new Image()
      this.backgroundImageFile.src = this.design.backgroundImage
      this.backgroundImageFile.onload = () => {
        this.animate()
        // this.drawFrame({ waveform: sampleWave })
      }
    }
  },
  methods: {
    resize() {
      const container = this.$refs['preview-container']
      if (container) {
        const maxWidth = container.clientWidth
        const maxHeight = 360
        const widthFactor = maxWidth / this.design.width // max 640 pixels wide
        const heightFactor = maxHeight / this.design.height // or 360 pixels tall
        const factor = Math.min(widthFactor, heightFactor)
        this.canvasHeight = factor * this.design.height
        this.canvasWidth = factor * this.design.width
        this.ctx.setTransform(factor, 0, 0, factor, 0, 0)
      }
    },
    animate() {
      this.animationFrame += 1
      if (this.animationFrame >= this.totalFrames) {
        this.animationFrame = 0
      }
      this.drawFrame({
        time: this.animationFrame,
        totalTime: this.totalFrames,
        waveform: sampleWaves[this.animationFrame]
      })
      this.animationTimeout = setTimeout(
        () => { this.animate() },
        this.refreshTimeout,
      )
    },
    drawFrame({ time = 68, totalTime = 100, waveform }) {
      this.resize()
      const factor = this.canvasWidth / this.design.width
      this.ctx.setTransform(factor, 0, 0, factor, 0, 0)
      this.ctx.clearRect(0, 0, this.design.width, this.design.height)
      this.ctx.fillStyle = this.design.backgroundColor
      this.ctx.fillRect(0, 0, this.design.width, this.design.height)
      if (this.backgroundImageFile) {
        this.ctx.drawImage(this.backgroundImageFile, 0, 0, this.design.width, this.design.height)
      }
      if (this.design.progressBar) {
        progressBars[this.design.progressBarType]({
          ctx: this.ctx,
          theme: this.design,
          time,
          totalTime,
        })
      }
      if (this.design.waveform) {
        animations[this.design.pattern || 'wave'](this.ctx, waveform, this.design)
      }

      if (this.watermark) {
        let watermarkPosition = -250
        const watermarkFinalPosition = 50
        const timeRatio = time / totalTime
        if (timeRatio > 0.75) {
          watermarkPosition = 50 - 300 / 0.25 * (timeRatio - 0.75)
        } else if (timeRatio > 0.25) {
          watermarkPosition = watermarkFinalPosition
        } else {
          watermarkPosition = -250 + 300 / 0.25 * timeRatio
        }
        if (watermarkLoaded) {
          this.ctx.drawImage(watermarkImg, this.design.width / 2 - watermarkImg.width / 2, watermarkPosition)
        } else {
          watermarkImg = new Image()
          watermarkImg.src = WATERMARK_SRC
          watermarkImg.onload = () => {
            watermarkLoaded = true
            this.ctx.drawImage(watermarkImg, this.design.width / 2 - watermarkImg.width / 2, watermarkPosition)
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
canvas {
  box-shadow: 0 4px 8px 0 rgba(100,100,100,.1), 0 6px 20px 0 rgba(100,100,100,.09);
}
</style>
